import './bthumbles/style';
import FormStructure from './bthumbles/form_structure';

export default FormStructure;